import { SvgProps } from "components/icons/types";

export const MenuDotsVertical = (props: SvgProps) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="6" cy="2.5" r="1.15" fill="currentColor" />
      <circle cx="6" cy="6" r="1.15" fill="currentColor" />
      <circle cx="6" cy="9.5" r="1.15" fill="currentColor" />
    </svg>
  );
};
